module.exports = "/images/intercard.white.svg?f3c1a96e16f8a5835c948061f14bad04";